<template>
    <flex-element :element-type="elementType" tag="a" class-default-inline="f-flex f-items-center f-mt-1">
        <a-text-single-line
            class-default="f-text-1 f-font-bold"
            v-bind="element(1)"
            @element-updated="elementUpdated"
        >
            Learn more
        </a-text-single-line>

        <a-icon
            icon-default="long-arrow-right"
            set-default="fal"
            class-default="f-text-1 f-text-red-600 f-ml-0.5"
            v-bind="element(2)"
            @element-updated="elementUpdated"
        />
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-smart';

export default {
    name: 'icon-link',
    mixins: [baseOrganism],

    props: {
        displayName: {
            type: String,
            default: 'Link',
        },

        isLink: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            isLinkNew: true, // Override to true to force link builder
        };
    },
};
</script>
